import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface SubscribeListReq {
  /** 每页数量 */
  limit?: number
  /** 页码 */
  page?: number
  permission_names?: string[]
  area_type?: number
}

export interface OrderList {
  /** 订阅时间 */
  create_time: string
  /** 订单号 */
  order_id: string
  /** 商品id */
  product_id: number
  /** 周期数量，比如date_kind=4，cycle_count=2，表示2年 */
  date_kind: number
  /** 服务期限类型 1-日、2-月、3-季、4-年 */
  cycle_count: number
  /** 剩余时效（天） */
  balance_day?: number
  /** 加速消耗天数 */
  consumption_day?: number
  /** 购买数量 */
  count?: number
  /** 服务状态 1-待使用，2-使用中 3-已完成 */
  status?: number
}

export interface ServiceList {
  /** 服务时效（过期天数） */
  expires_days: number
  /** 分类名称 */
  class_name?: string
  /** 授权数量 */
  count?: number
  terminal_count?: number
  /** 数据类型 1-免费 2-收费 3-待开放 */
  data_type?: number
  /** 权益服务名称 */
  display_name?: string
  /** logo */
  logo?: string
  order_list?: OrderList[]
  /** 权益服务key */
  permission_name?: string
  price_id?: number
  package_price_id?: number
  /** 状态 1-待使用，2-使用中 3-已完成 */
  status?: number
  /** 支持系统 */
  support_system_types?: number[]
  /** 类型 1-试用 2-订阅 */
  type?: number
  /** 前端字段 */
  is_check?: boolean
}

export interface SubscribeListRes {
  service_list?: ServiceList[]
  total?: number
}

export interface ServiceOptionReq {
  area_type?: number
}

export interface ServiceOption {
  name: string
  permission_names: string[]
  child?: ServiceOption[]
  /** 前端字段 是否叶子节点 */
  leaf?: boolean
}

export interface ServiceOptionRes {
  /** 分类信息 */
  service_type: ServiceOption[]
}

@Injectable()
export class MySubscribeService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  getSubscribeList (data: SubscribeListReq) {
    return this.http.post<SubscribeListRes>('/permission_order/service_list', data)
  }

  getServiceOption (data: ServiceOptionReq = {}) {
    return this.http.post<ServiceOptionRes>('/permission_order/service_type', data).then(res => {
      res.service_type = res.service_type.filter(v => v.child.length)

      res.service_type = [
        { name: '全部已订阅服务', permission_names: [] },
        ...res.service_type
      ]
      const deep = (list: ServiceOption[]) => {
        list.forEach(tree => {
          tree.leaf = !tree.child?.length
          if (tree.child?.length) {
            deep(tree.child)
          }
        })
      }
      deep(res.service_type)
      return res
    })
  }
}
